import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_ru.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.ru.js'
import 'moment/locale/ru.js'
import './translations.tc.ru.js'

$.fn.datepicker.defaults.language = 'ru'

I18n.defaultLocale = 'ru'
I18n.locale = 'ru'

export default App
